import * as Sentry from '@sentry/core'

const addSentrySessionData = (payload: { email: string; auth0Id: string; accountId: string }) => {
  Sentry.setUser({
    email: payload.email,
    id: `${payload.auth0Id}-${payload.accountId}`,
  })
}
export { addSentrySessionData }
